import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  right: 70px;
  bottom: 70px;
  z-index: 20;

  @media (max-width: 480px) {
    right: 50px;
    bottom: 50px;
  }
`;

export const Link = styled.a`
  background: #1ebea5;
  width: 70px;
  height: 70px;

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: 0.5s all;
  animation: pulse 2s infinite, move 1s forwards;
  animation-delay: 0.5s;
  transform: translateX(300%);

  & svg {
    height: 40px;
    fill: #fff;
    pointer-events: none;
  }
`;
